import { Popover } from '@mui/material';
import { ShareArtifactContent, ShareArtifactContentProps } from './ShareArtifactContent';

export interface ShareArtifactPopoverProps extends Omit<ShareArtifactContentProps, 'isOpen'> {
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

export const ShareArtifactPopover = ({
  anchorEl,
  onClose,
  artifact,
  showShareSection = true,
  type,
}: ShareArtifactPopoverProps) => {
  const isOpen = Boolean(anchorEl);

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: {
            width: '448px',
            borderRadius: '8px',
            boxShadow: '0px 4px 24px 0px rgba(0, 0, 0, 0.12)',
            mt: 1,
          },
        },
      }}
    >
      <ShareArtifactContent
        artifact={artifact}
        isOpen={isOpen}
        showShareSection={showShareSection}
        type={type}
      />
    </Popover>
  );
};
